export const removeLeadingZeros = (str: string | undefined) => {
  if (typeof str !== 'string') return;
  return String(Number(str));
};
